import PropTypes from 'prop-types';

import { useIntl } from '~/techstyle-shared/react-intl';

const DynamicText = ({ condition, defaultText, conditionalText }) => {
  const intl = useIntl();
  return intl.formatMessage(condition ? conditionalText : defaultText);
};

DynamicText.propTypes = {
  condition: PropTypes.bool.isRequired,
  conditionalText: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string.isRequired,
  }),
  defaultText: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string.isRequired,
  }),
};

export default DynamicText;
